import { render, staticRenderFns } from "./EmployeePay.vue?vue&type=template&id=4bf89cb7&"
import script from "./EmployeePay.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeePay.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeePay.vue?vue&type=style&index=0&id=4bf89cb7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports